import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getProductTypesRequest, getProductTypesRequestError, getProductTypesRequestSuccess } from "../../slices/Content/GetProductTypesSlice";

export const GetProductTypesApi = (page, limit, status, search) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        status: status,
        search: search
    }).toString();

    const urlWithParams = `${endpoints.getContentProductTypes}?${queryParams}`;

    try {
        dispatch(getProductTypesRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getProductTypesRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getProductTypesRequestError(_error));
            });
    } catch (error) { }
};
